"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderType = void 0;
const validation_1 = require("../validation");
/**
 * Different supported providers
 * @alpha
 */
var ProviderType;
(function (ProviderType) {
    ProviderType["INJECTED"] = "injected";
    ProviderType["FORTMATIC"] = "formatic";
    ProviderType["NETWORK"] = "network";
    ProviderType["WALLET_CONNECT"] = "wallet_connect";
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
/**
 * @alpha
 */
(function (ProviderType) {
    ProviderType.schema = {
        type: 'string',
        enum: Object.values(ProviderType)
    };
    ProviderType.validate = (0, validation_1.generateValidator)(ProviderType.schema);
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
//# sourceMappingURL=provider-type.js.map